import axios from 'axios'; // eslint-disable-line

export const checkProjectConfig = (projectId) => { return axios.get(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/checklatest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`); };

export const publishProject = (projectId) => {
    return axios({
        method: 'PUT',
        url: `${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/versions/publishVersion/latest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`,
    });
};
